import { Star, Quote } from "lucide-react";

const REVIEWS = [
  {
    name: "Rajesh Sharma",
    role: "Truck Owner, Indore",
    text: "Beemamen ne mere truck ka claim bina kisi tension ke settle karwaya. Bahut professional team hai.",
    rating: 5,
    avatar:
      "https://images.pexels.com/photos/8819145/pexels-photo-8819145.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
  },
  {
    name: "Priya & family",
    role: "Health Plan Customer",
    text: "Hospital bill ka stress khatam ho gaya. Cashless treatment aur 24x7 support — exactly what we needed.",
    rating: 5,
    avatar:
      "https://images.pexels.com/photos/14124346/pexels-photo-14124346.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
  },
  {
    name: "Manoj Patidar",
    role: "Farmer, Madhya Pradesh",
    text: "Tractor insurance lene mein bahut help mili. Kam premium aur achi cover — ab kheti ki tension kam hai.",
    rating: 5,
    avatar:
      "https://images.pexels.com/photos/8819145/pexels-photo-8819145.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=200&w=200",
  },
];

export default function Testimonials() {
  return (
    <section data-testid="testimonials-section" className="py-16 md:py-24 bg-[#fef9ec]">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="max-w-2xl">
          <span className="eyebrow">Customer Stories</span>
          <h2 className="font-display mt-4 text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            10,000+ families,<br /> truckers & farmers trust us.
          </h2>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {REVIEWS.map((r, i) => (
            <article
              key={r.name}
              data-testid={`testimonial-${i}`}
              className="relative p-7 rounded-2xl bg-white border border-amber-200 shadow-sm hover:shadow-lg transition-all"
            >
              <Quote className="w-7 h-7 text-[#f5b942] absolute top-5 right-5 opacity-50" />
              <div className="flex items-center gap-1 text-[#f5b942]">
                {Array.from({ length: r.rating }).map((_, j) => (
                  <Star key={j} className="w-4 h-4 fill-current" />
                ))}
              </div>
              <p className="mt-4 text-slate-700 leading-relaxed">&ldquo;{r.text}&rdquo;</p>
              <div className="mt-5 flex items-center gap-3">
                <img
                  src={r.avatar}
                  alt={r.name}
                  className="w-11 h-11 rounded-full object-cover border-2 border-white shadow"
                />
                <div>
                  <div className="font-bold text-slate-900 text-sm">{r.name}</div>
                  <div className="text-xs text-slate-500">{r.role}</div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
